import { NgModule } from '@angular/core';

import { MenuClearButtonComponent } from './components/menu-clear-button/menu-clear-button.component';
import { ReachMenuComponent, ReachMenuSectionDirective } from './main/main-menu.directive';

export { WidthSize } from './components/floating/floating.component';
export { WarningTemplateComponent } from './components/warning-template/warning-template.component';
export { ReachMenuComponent, ReachMenuSectionDirective } from './main/main-menu.directive';
export { MenuDesktopType } from './types/desktop';
export { openMenuWithResult } from './utils/open-menu-with-result';

@NgModule({
	imports: [ReachMenuComponent, ReachMenuSectionDirective, MenuClearButtonComponent],
	exports: [ReachMenuComponent, ReachMenuSectionDirective, MenuClearButtonComponent],
})
export class ReachMenuModule {}
